module.exports = function getResource(label, vars = []) {
    let resources = {
        startAReturn: 'Start a return'
    };

    return resources[label];
};
